module.exports = __webpack_public_path__ + "img/glasses-9-3.3512b204.svg";